import {Component, OnInit, Input, forwardRef, ChangeDetectorRef, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { InputGridColumnsDatasourceMappingModel } from './input-grid-columns-datasource-mapping.model';
import { MatDialog } from '@angular/material/dialog';
import { InputGridColumnsDatasourceMappingDialogComponent } from '../input-grid-columns-datasource-mapping-dialog/input-grid-columns-datasource-mapping-dialog.component';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { Model_WorkflowComponent, Model_Datasource, AbwDatasourceFilter, AbwDatasourceColumn } from 'src/app/app.models';

@Component({
    selector: 'abw-input-grid-columns-datasource-mapping',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputGridColumnsDatasourceMappingComponent),
        multi: true
      }
    ],
    templateUrl: './input-grid-columns-datasource-mapping.component.html',
    styleUrls: ['./input-grid-columns-datasource-mapping.component.scss']
})
export class InputGridColumnsDatasourceMappingComponent extends AbstractWorkflowFormComponent<InputGridColumnsDatasourceMappingModel, any> {
	@Input() model: InputGridColumnsDatasourceMappingModel; 
    @Input() value: any[] = [];
    gridColumns: Model_WorkflowComponent[] = [];
    datasourceColumns: AbwDatasourceColumn[] = [];

    constructor(
      private dialog: MatDialog,
      _workflowComponentsService: WorkflowComponentsService,
      _cdf: ChangeDetectorRef,
      _injector: Injector
    ) {
      super(_workflowComponentsService, _cdf, _injector);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: any[]) {
        this.value = value; 
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(InputGridColumnsDatasourceMappingDialogComponent, {
            data: { 
                gridColumns: this.gridColumns,
                datasourceColumns: this.datasourceColumns,
                columnsMapping: this.value || []
            },
            panelClass: 'custom-modal'
        });
    
        dialogRef.afterClosed().subscribe((result?: any) => {
            if (result === undefined) { return; }
            this.value = result;
            this.onValueChanged(this.value); 
        });
    }
}